// import { CircularProgress } from '@mui/material';
import React from 'react';
import { useSelector } from 'store';

function LoadingSpinner() {
    const { isShow } = useSelector((state) => state.loading);
    return (
        <React.Fragment>
            {isShow && (
                <div className='loading-overlay'>
                    <div className='spinner'></div>
                </div>
            )}
        </React.Fragment>
    );
}

export default LoadingSpinner;
